import { Form, Rate } from 'antd';
import { StyledStarRating } from './style';
import { Rule } from 'rc-field-form/lib/interface';
import { FormItemLayout } from 'antd/es/form/Form';

interface StarRatingProps {
  value?: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
  allowClear?: boolean;
  count?: number;
  label?: string;
  name?: (string | number)[] | string | number;
  rules?: Rule[];
  className?: string;
  validateTrigger?: string | string[];
  noStyle?: boolean;
  initialValue?: number;
  layout?: FormItemLayout;
}

const StarRating = ({
  value,
  onChange,
  disabled = false,
  allowClear = true,
  count = 5,
  label,
  name,
  rules,
  className,
  validateTrigger,
  noStyle,
  initialValue,
  layout,
}: StarRatingProps) => {
  return (
    <StyledStarRating className="star-rating-wrapper">
      <Form.Item
        initialValue={initialValue}
        label={label}
        name={name}
        rules={rules}
        className={className}
        validateTrigger={validateTrigger}
        noStyle={noStyle}
        layout={layout}
      >
        <Rate
          value={value}
          onChange={onChange}
          disabled={disabled}
          allowClear={allowClear}
          count={count}
        />
      </Form.Item>
    </StyledStarRating>
  );
};

export default StarRating;